<template>
  <div class="app">
    <!-- <script v-if="meta_structuredData" type="application/ld+json" v-html="meta_structuredData" /> -->
    <GlobalEvents @click="routerLink($event)" />
    <navbar v-if="isPageValid"
            ref="navbarContainer"
            text-title="Exclusive Villas"
            text-arrival="Check-in"
            text-departure="Check-out"
            text-destination-label="All destinations"
            text-find-villas="Search villas"
            region="homepage"
            section="nav"
    />
    <div id="content" class="app-content" :class="isPageValid ? 'nav-margin' : ''" :style="!isPageValid ? scaLayoutStyles : ''">
      <!-- <transition name="slide" mode="out-in"> -->
      <app-client-area-login v-if="showLogin" />
      <div v-if="!isPageValid" class="sca-nav">
        <transition name="fade" mode="out-in">
          <CALoadInScreen v-if="displayLoader" />
        </transition>
        <CADesktopNav v-if="!isScaMobile" :compact="scaNavCompact" @changed="onScaNavChanged" />
        <CAMobileNav v-if="isScaMobile" />
      </div>
      <div v-if="isFullHeight">
        <hero class="background-offwhite" />
      </div>
      <div>
        <component
          :is="currentTemplate"
          v-if="!showLogin"
          :key="currentPath"
          :class="isPageValid ? 'app-content-main' : 'app-conent-sca'"
        />
      </div>

      <!-- </transition> -->
    </div>
    <mobile-search v-if="isMobile" />
    <Footer v-if="isPageValid" />
    <!--<cookienotice />-->
    <overlay />
    <!-- <stay-in-touch /> -->
    <!-- <new-destination-popup /> -->
    <!-- <mallorca-pop-up /> -->
    <!-- <italian-covid19-popup v-if="showItalyPopup" />
  <german-covid19-popup v-if="showGermanyPopup" />
  <france-popup v-if="showFrancePopup" /> -->
    <div v-if="fakeFullScreen" id="fakeFullScreenApp" class="fullscreen-cover" />
    <v-tour v-if="isTourAvailable && isDesktop" name="myTour" :steps="getSteps" :options="tourOptions" />
  </div>
</template>

<script>
import { _ } from 'vue-underscore';
import 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import Validator from 'vee-validate';
import Navbar from './components/nav/Main';
import AppClientAreaLogin from './pages/secure/clientarea/CALogin.vue';
import MobileSearch from './components/MobileSearch.vue';
import Footer from './components/Footer';
import LanguageNotice from './components/LanguageNotice';
import routerLink from './mixins/routerLink';
import closeTab from './mixins/closeTab';
import responsive from './mixins/responsive';
import tourSteps from './content/secure/TourSteps';
import CALoadInScreen from './components/CALoadInScreen.vue';
import Hero from './pages/home/Hero';

// import StayInTouch from './components/StayInTouch.vue';
// import NewDestinationPopup from './components/NewDestinationPopup.vue';
// import MallorcaPopUp from './components/MallorcaPopUp.vue';
import cfg from './config/config.js';
import Bus from './events/bus.js';

const Overlay = () => import('./components/Overlay.vue');
// const ItalianCovid19Popup = () => import('./components/ItalianCovid19Popup.vue');
// const GermanCovid19Popup = () => import('./components/GermanCovid19Popup.vue');
// const FrancePopup = () => import('./components/FrancePopup.vue');
const CADesktopNav = () => import('./pages/secure/clientarea/shared/CADesktopNav.vue');
const CAMobileNav = () => import('./pages/secure/clientarea/shared/CAMobileNav.vue');

export default {
  name: 'App',
  components: {
    AppClientAreaLogin,
    Navbar,
    Footer,
    CALoadInScreen,
    Overlay,
    // StayInTouch,
    // NewDestinationPopup,
    // ItalianCovid19Popup,
    // GermanCovid19Popup,
    // FrancePopup,
    LanguageNotice,
    MobileSearch,
    CADesktopNav,
    CAMobileNav,
    Hero,
    // MallorcaPopUp
  },
  mixins: [
    routerLink,
    closeTab,
    responsive,
  ],
  data() {
    return {
      imageObserverStarted: false,
      screenData: {},
      onResizeDebouncedTimeout: null,
      onResetDebouncedTimeout: null,
      resizeDone: false,
      // sca
      compactBreakpoint: 1300,
      scaNavOpen: true,
      scaNavCompact: false,
      tourSteps,
      startTime: 0,
      endTime: 0,
      landingRoute: '',
      routerPath: '',
    };
  },
  metaInfo() {
    return {
      title: this.currentPage && this.currentPage.id != 5 ? ' - The Thinking Traveller' : '',
      titleTemplate: `${this.currentPageTitle}%s`,
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'description', content: this.currentPageMetaDescription },
        { name: 'keywords', content: this.currentPageMetaKeywords },
        // ...this.currentSwiftypMeta
      ],
      link: [
        { rel: 'favicon', href: '/favicon.png' },
        { rel: 'canonical', href: this.pageCanonicalURL },
      ],
      script: [{
        type: 'application/ld+json',
        json: { '@context': 'https://schema.org', '@graph': this.meta_structuredData },
      }],
    };
  },
  computed: {
    isFullHeight() {
      return this.currentTemplateID == 3 || this.$router.currentRoute.path === '/';
    },
    dataLoaded() {
      return this.$store.getters['common/getApiDataLoaded'];
    },
    scaLayoutStyles() {
      return {
        display: 'grid',
        gap: '0px',
        gridTemplateColumns: this.isScaMobile
          ? '1fr'
          : this.scaNavOpen && !this.scaNavCompact
            ? '220px 1fr'
            : '50px 1fr',
      };
    },
    isPageValid() {
      return this.showLogin || !this.$router.currentRoute.path.includes('/secure') || !!this.$router.currentRoute.path.includes('/secure/ob');
    },
    currentTemplateID() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId : 0;
    },

    displayLoader() {
      return this.$store.getters['bookings/displayLoader'];
    },

    fakeFullScreen() {
      return this.$store.getters['common/getFakeFullScreen'];
    },
    showItalyPopup() {
      return ['it', 'ita'].includes(this.$store.getters['common/getOfficeStatus'].countryCode) || this.$route.query.test_italian_covid_popup;
    },
    showGermanyPopup() {
      return ['de'].includes(this.$store.getters['common/getOfficeStatus'].countryCode) || this.$route.query.test_german_covid_popup;
    },
    showFrancePopup() {
      return ['fr'].includes(this.$store.getters['common/getOfficeStatus'].countryCode) || this.$route.query.test_france_popup;
    },
    showLogin() {
      // show login screen if current page is secure and user is not logged in
      // or if user is logged in but as a OB checkout guest

      return ((this.$store.getters['pages/isCurrentPageSecure'] &&
          !this.$store.getters['users/loggedInUser'])
          || (this.$store.getters['users/loggedInUser'] &&
            this.$store.getters['users/loggedInUser'].guest &&
          this.$store.getters['pages/isCurrentPageSecure']));

      /// / check token cookie here instead of LoggedInUser state (LoggedInUser state relies on fetchLoggedInUser to return first so if this is evaluated and state is still null then login shows and that forces a logout)

      // return ((this.$store.getters['pages/isCurrentPageSecure'] &&
      //  !$cookies.get('user_api_token'))
      //  || (this.$store.getters['users/loggedInUser'] &&
      //    this.$store.getters['users/loggedInUser'].guest &&
      //    this.$store.getters['pages/isCurrentPageSecure']));
    },

    currentPath() {
      return this.$store.getters['pages/currentPath'];
    },
    currentPage() {
      return this.$store.getters['pages/currentPage'];
    },
    currentPageLS() {
      return this.$store.getters['pages/currentPageLS'];
    },
    currentTemplate() {
      return this.$store.getters['templates/currentTemplate'] ? this.$store.getters['templates/currentTemplate'].tag : '';
    },
    currentPageType() {
      return this.$store.getters['pages/currentPageType'];
    },
    currentProperty() {
      return this.$store.getters['properties/getCurrentProperty'];
    },
    currentCollection() {
      return this.$store.getters['lists/getCurrentList'];
    },
    currentExperience() {
      return this.$store.getters['experiences/getCurrentExperience'];
    },
    currentExperienceGroup() {
      return this.$store.getters['experiences/getCurrentExperienceGroup'];
    },
    currentPress() {
      return this.$store.getters['presspages/getCurrentPressPage'];
    },
    currentBlog() {
      return this.$store.getters['blogs/getCurrentBlogArticlePage'];
    },
    currentBlogTag() {
      return this.$store.getters['blogs/getCurrentBlogTag'];
    },
    currentPageTitle() {
      if (this.currentPageType === 'cms') return this.currentPageLS ? this.currentPageLS.title : '';
      if (this.currentPageType === 'villa') {
        return this.currentProperty ? this.currentProperty.pageTitle : '';
      }
      if (this.currentPageType === 'collection') {
        return this.currentCollection ? this.currentCollection.pageTitle : '';
      }
      if (this.currentPageType === 'experience') {
        return this.currentExperience ? this.currentExperience.browserTitle : '';
      }
      if (this.currentPageType === 'experiencegroup') {
        return this.currentExperienceGroup ? this.currentExperienceGroup.tier.title : '';
      }
      if (this.currentPageType === 'press') {
        return this.currentPress ? this.currentPress.pageTitle : '';
      }
      if (this.currentPageType === 'blogarticle') {
        return this.currentBlog ? this.currentBlog.languageSpecificBlogs[0].title : '';
      }
      if (this.currentPageType === 'blogtag') {
        return this.currentBlogTag ? this.currentBlogTag.pageTitle : '';
      }
    },
    currentPageMetaDescription() {
      if (this.currentPageType === 'cms') return this.currentPageLS ? this.currentPageLS.metaDescription : '';
      if (this.currentPageType === 'villa') {
        return this.currentProperty ? this.currentProperty.metaDescription : '';
      }
      if (this.currentPageType === 'collection') {
        return this.currentCollection ? this.currentCollection.metaDescription : '';
      }
      if (this.currentPageType === 'experience') {
        return this.currentExperience ? this.currentExperience.metaDescription : '';
      }
      if (this.currentPageType === 'press') {
        return this.currentPress ? this.currentPress.introText : '';
      }
      if (this.currentPageType === 'blogarticle') {
        return this.currentBlog ? this.currentBlog.languageSpecificBlogs[0].metaDescription : '';
      }
      if (this.currentPageType === 'blogtag') {
        return this.currentBlogTag ? this.currentBlogTag.languageSpecificTags[0].metaDescription : '';
      }
    },
    currentPageMetaKeywords() {
      if (this.currentPageType === 'cms') return this.currentPageLS ? this.currentPageLS.metaKeywords : '';
      if (this.currentPageType === 'villa') {
        return this.currentProperty ? this.currentProperty.metaKeywords : '';
      }
      if (this.currentPageType === 'collection') {
        return this.currentCollection ? this.currentCollection.metaKeywords : '';
      }
      if (this.currentPageType === 'experience') {
        return this.currentExperience ? this.currentExperience.metaKeywords : '';
      }
      if (this.currentPageType === 'press') {
        return ''; // todo: add property to press page objects to use here
      }
      if (this.currentPageType === 'blogarticle') {
        return this.currentBlog ? this.currentBlog.languageSpecificBlogs[0].metaKeywords : '';
      }
      if (this.currentPageType === 'blogtag') {
        return this.currentBlogTag ? this.currentBlogTag.languageSpecificTags[0].metaKeywords : '';
      }
    },
    meta_structuredData() {
      const graph = [];
      // add auto generated breadcrumb type
      graph.push({ '@type': 'BreadcrumbList', itemListElement: this.pageStructuredBreadCrumb });

      let structuredData;
      // add any other structured data was manually set at page level in CMS or Admin (blog tag, blog article pages)
      if (this.currentPageType === 'cms' && this.currentPageLS && this.currentPageLS.structuredSchema !== '') {
        structuredData = this.replaceSpecialChars(this.currentPageLS.structuredSchema);
      } else if (this.currentPageType === 'blogarticle' && this.currentBlog && this.currentBlog.languageSpecificBlogs[0].structuredSchema !== '') {
        structuredData = this.replaceSpecialChars(this.currentBlog.languageSpecificBlogs[0].structuredSchema);
      } else if (this.currentPageType === 'blogtag' && this.currentBlogTag && this.currentBlogTag.languageSpecificTags[0].structuredSchema !== '') {
        structuredData = this.replaceSpecialChars(this.currentBlogTag.languageSpecificTags[0].structuredSchema);
      }

      if (structuredData && this.isValidJSONString(structuredData)) {
        structuredData = JSON.parse(structuredData);
        if (Array.isArray(structuredData)) {
          structuredData.forEach((sd) => {
            graph.push(sd);
          });
        } else {
          graph.push(structuredData);
        }
      }
      return graph;
    },
    pagePathEN() {
      return this.currentPage ? this.getAltURL('en') : '';
    },
    pageCanonicalPathEN() {
      return this.currentPage ? this.getCanonicalURL('en') : '';
    },
    pageCanonicalURL() {
      if (this.currentPageType === 'cms') {
        return this.pageCanonicalPathEN;
      }
      if (this.currentPageType === 'villa') {
        return this.currentProperty ? `https://${location.host}${this.currentProperty.cmsRelativeURL}` : '';
      }
      if (this.currentPageType === 'collection') {
        return this.currentCollection ? `https://${location.host}${this.currentCollection.cmsRelativeURL}` : '';
      }
      if (this.currentPageType === 'press') {
        return this.currentPress ? `https://${location.host}${this.currentPress.cmsRelativeURL}` : '';
      }
      if (this.currentPageType === 'blogarticle') {
        return this.currentBlog ? `https://${location.host}${this.currentBlog.cmsRelativeURL}` : '';
      }
      if (this.currentPageType === 'blogtag') {
        return this.currentBlogTag ? `https://${location.host}${this.currentBlogTag.blogTagCMSRelativeURL}` : '';
      }

      return '';
    },
    pageAncesstors() {
      return this.$store.getters['pages/currentPageAncesstors'];
    },
    pageStructuredBreadCrumb() {
      const items = [];

      if (this.currentPageType === 'cms' && this.pageAncesstors) {
        // add current page's ancestors
        this.pageAncesstors.forEach((p, i) => {
          items.push({ '@type': 'ListItem', position: (i + 1), item: { '@id': `https://${location.host}${p.path}`, name: `${p.title}` } });
        });
        // add current page as well
        if (this.currentPageLS) {
          items.push({ '@type': 'ListItem', position: (this.pageAncesstors.length + 1), item: { '@id': `${this.pagePathEN}`, name: `${this.currentPageTitle}` } });
        }
      } else if ((this.currentPageType === 'villa' || this.currentPageType === 'collection' || this.currentPageType === 'press' || this.currentPageType === 'blogarticle' || this.currentPageType === 'blogtag') && this.pageCanonicalURL) {
        const segments = this.pageCanonicalURL.split('/');

        // add home
        items.push({ '@type': 'ListItem', position: 1, item: { '@id': `https://${location.host}`, name: 'home' } });

        let url = '';
        let count = 2;
        segments.forEach((s, i) => {
          url += `${i > 0 ? '/' : ''}${s}`;
          if (i > 2 && s != 'villas') {
            items.push({ '@type': 'ListItem', position: count, item: { '@id': `${url}`, name: `${s.replace(/-/g, ' ')}` } });
            count++;
          }
        });
      }
      return items;
    },
    isTourAvailable() {
      if (this.currentPage) return [82, 771].includes(this.currentPage.id);
    },
    getSteps() {
      const pageId = this.currentPage.id;
      const steps = this.tourSteps.pages.filter((page) => pageId == page.pageId);
      return steps[0].steps;
    },
    tourOptions() {
      return {
        highlight: true,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Close',
        },
        enabledButtons: {
          buttonSkip: this.currentPage.id != 771,
          buttonPrevious: false,
        },
      };
    },
    // currentSwiftypMeta() {
    //  let items = []
    //  if (this.currentPageType === 'cms') {
    //    if (this.currentTemplate.search("app-template-home") >= 0) {
    //      items = [
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_type', content: 'Home Page' },
    //      ]
    //    } else if (this.currentTemplate.search("app-template-regions") >= 0) {
    //      items = [
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_type', content: 'Region' },
    //      ]
    //    } else if (this.currentTemplate.search("app-template-guide") >= 0) {
    //      let regionId = cfg.regions.find((r) => r.guideID === this.currentPage.id).id;
    //      let region = this.$store.getters['regions/getRegionById'](regionId);
    //      items = [
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_type', content: 'Guide' },
    //        { class: 'swiftype', 'data-type': 'string', name: 'guide_type', content: !!region ? region.description : '' },
    //      ]
    //    } else if (this.currentTemplate.search("app-template-villacollections") >= 0) {
    //      items = [
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_type', content: 'Collection' },
    //      ]
    //    } else {
    //      items = [
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_type', content: 'Guide' },
    //        { class: 'swiftype', 'data-type': 'string', name: 'guide_page', content: '1' },
    //      ]
    //    }
    //  }
    //  else if (this.currentPageType === 'villa') {
    //    // find the villa card in allProperties
    //    if (this.currentProperty) {
    //      let villaCard = (this.$store.getters['properties/getProperyById'](this.currentProperty.id));
    //      items = [
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_type', content: 'Villa' },
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_image', content: `${cfg.rootCardImgs}${villaCard.img1}` },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_name', content: villaCard.name },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_description', content: villaCard.sum },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_region', content: this.$store.getters['regions/getRegionById'](villaCard.regionId).description },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_region_sub', content: this.$store.getters['regions/getSubRegionById'](villaCard.subRegionId).description },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_sleeps', content: villaCard.sleeps },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_beds', content: villaCard.beds },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_baths', content: villaCard.baths },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_exquisite', content: villaCard.te },
    //        { class: 'swiftype', 'data-type': 'string', name: 'villa_hideforitaly', content: villaCard.hideforitaly },
    //      ];
    //    }
    //  }
    //  else if (this.currentPageType === 'collection') {
    //    if (this.currentCollection) {
    //      items = [
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_type', content: 'Collection' },
    //        { class: 'swiftype', 'data-type': 'string', name: 'page_image', content: `${cfg.rootMediaLib}${this.currentCollection.image }` },
    //        { class: 'swiftype', 'data-type': 'string', name: 'collection_villa_amount', content: this.currentCollection.propertyCount },
    //      ]
    //    }

    //  }
    //  return items
    // },

  },
  watch: {
    fakeFullScreen(n) {
      const body = document.body;
      if (n) {
        body.style.height = '100vh';
        body.style.overflowY = 'hidden';
      }
      else {
        body.style.height = '';
        body.style.overflowY = '';
      }
    },
  },

  created() {
    this.checkLandingPage();
    this.$store.dispatch('villaviews/setStoredData');
    this.handleFlagSetRequest();
    this.runCookies();
  },
  mounted() {
    this.$router.afterEach((to) => {
      // Only fetch a new path if it is different to the current path.
      if ((to.path != this.routerPath && to.path != this.$store.getters['pages/currentPath'])) {
        this.routerPath = to.path;
        this.$store.dispatch('pages/fetchPageByPath', to.path);
      }
    });

    this.setupVeeValidate();
    this.setupScreenResize();

    // covers lazyloading for cms html module content (where we cannot use our custom v-lazyload directive)
    window.addEventListener('scroll', this.doLazyLoad);
    Bus.$on('setNavCompactBreakpoint', this.setNavCompactBreakpoint);
    Bus.$on('startTour', this.startTour);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.doLazyLoad);
    Bus.$off('setNavCompactBreakpoint', this.setNavCompactBreakpoint);
    Bus.$off('startTour', this.startTour);
  },
  methods: {
    checkLandingPage() {
      this.landingRoute = this.$router.currentRoute.path;
      if (this.landingRoute.includes('/villas/')) {
        this.landingRoute = 'villa';
      }
      switch (this.landingRoute) {
        case '/':
          this.loadPrimaryData('home');
          break;
        case '/results':
          this.loadPrimaryData('results');
          break;
        case 'villa':
          this.loadPrimaryData('villa');
          break;
        default:
          this.loadPrimaryData('all');
          break;
      }
    },
    loadExternalScripts() {
      // global function do not remove or edit
      // eslint-disable-next-line no-undef
      loadAllExternalScripts();
    },
    loadPrimaryData(route) {
      const promise1 = this.$store.dispatch('pages/fetchPrimaryData', route);
      let promises = [promise1];

      if (route === 'all') {
        const promise2 = this.$store.dispatch('users/fetchLoggedInUser');
        const promise3 = this.$store.dispatch('bookings/fetchCurrentBooking');
        promises = [promise1, promise2, promise3];
      }

      Promise.allSettled(promises).then((results) => {
        this.$store.commit('common/setApiDataLoaded', true);
        route != 'all' ? this.loadSecondaryData(route) : null;
        setTimeout(() => this.loadExternalScripts(), 1000);
      });
    },

    loadSecondaryData(route) {
      const promise1 = this.$store.dispatch('pages/fetchSecondaryData', route);
      const promise2 = this.$store.dispatch('users/fetchLoggedInUser');
      const promise3 = this.$store.dispatch('bookings/fetchCurrentBooking');
      const promises = [promise1, promise2, promise3];

      Promise.allSettled(promises).then((results) => {
        this.$store.commit('common/setApiDataLoaded', true);
      });
    },
    runCookies() {
      // eslint-disable-next-line no-undef
      const cookie = initCookieConsent();
      cookie.run(cfg.vanillacookie);
    },
    isValidJSONString(json) {
      try { JSON.parse(json); } catch (e) { return false; }
      return true;
    },
    replaceSpecialChars(text) {
      return text.replace(/\\n/g, '\\n')
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, '\\&')
        .replace(/\\r/g, '\\r')
        .replace(/\\t/g, '\\t')
        .replace(/\\b/g, '\\b')
        .replace(/\\f/g, '\\f');
    },
    getNavbarHeight() {
      return document.querySelector('.navbar') ? document.querySelector('.navbar').offsetHeight : 0;
    },
    getAltURL(lang) {
      return `https://${location.host}${this.currentPage.paths ? this.currentPage.paths.find((o) => o.language === lang) ? this.currentPage.paths.find((o) => o.language === lang).path : '' : ''}`;
    },
    getCanonicalURL(lang) {
      // fallback to self referencing canonical not home page
      return `https://${location.host}${this.currentPage.paths ? this.currentPage.paths.find((o) => o.language === lang) ? this.currentPage.paths.find((o) => o.language === lang).path : location.pathname : location.pathname}`;
    },
    setupScreenResize() {
      this.resizeDone = false;
      window.addEventListener('resize', this.onScreenResize);
      this.onScreenResize();
    },
    debounceScreenResize() {
      window.clearTimeout(this.onResizeDebouncedTimeout);
      window.clearTimeout(this.onResetDebouncedTimeout);

      if (!this.resizeDone) {
        this.onResizeDebouncedTimeout = setTimeout(this.onScreenResize, 500);
        this.onResetDebouncedTimeout = setTimeout(this.resetScreenResize, 600);
        this.resizeDone = true;
      }
    },
    resetScreenResize() {
      this.resizeDone = false;
    },
    onScreenResize() {
      const screenWidth = document.documentElement.clientWidth;
      const screenHeight = window.outerHeight;
      const innerWidth = window.innerWidth;
      const innerHeight = window.innerHeight;
      // const clientWidth = document.documentElement.clientWidth;
      // const clientHeight = document.documentElement.clientHeight;
      // const offsetWidth =  document.body.offsetWidth;
      // const offsetHeight = document.body.offsetHeight;
      let screenType = '';
      let screenTypeSca = '';

      if (!!screenWidth && screenWidth > 0) {
        if (screenWidth <= cfg.breakpoints.mobile) {
          screenType = 'mobile';
        } else if (screenWidth > cfg.breakpoints.mobile && screenWidth <= cfg.breakpoints.tablet) {
          screenType = 'tablet';
        } else if (screenWidth >= cfg.breakpoints.desktop) {
          screenType = 'desktop';
        }

        if (screenWidth <= cfg.breakpoints.sca_mobile) {
          screenTypeSca = 'mobile';
        } else if (screenWidth > cfg.breakpoints.sca_mobile && screenWidth <= cfg.breakpoints.sca_tablet) {
          screenTypeSca = 'tablet';
        } else if (screenWidth >= cfg.breakpoints.sca_desktop) {
          screenTypeSca = 'desktop';
        }
      }

      this.screenData = {
        screenType, screenWidth, screenHeight, innerWidth, innerHeight,
      };

      this.$store.commit('common/setScreenType', screenType);
      this.$store.commit('common/setScreenSize', this.screenData);
      this.$store.commit('sca/setScreenType', screenTypeSca);
      this.$store.commit('sca/setScreenSize', this.screenData);
      Bus.$emit('onScreenResize', this.screenData);

      this.setScaNavCompact();

      if (!this.resizeDone) {
        this.debounceScreenResize();
      }
    },
    setScaNavCompact() {
      this.scaNavCompact = this.screenData.innerWidth <= this.compactBreakpoint;
    },
    setNavCompactBreakpoint(val) {
      if (val > 0) {
        this.compactBreakpoint = Number(val);
        this.setScaNavCompact();
      }
    },
    startTour() {
      this.$tours.myTour.start();
    },
    onScaNavChanged(opened) {
      this.scaNavOpen = opened;
    },
    doLazyLoad() {
      if ('IntersectionObserver' in window) {
        const lazyloadImages = document.querySelectorAll('.lazy');
        const options = {
          root: null,
          threshold: '0',
        };
        const imageObserver = new IntersectionObserver((entries, options) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const image = entry.target;
              image.src = image.dataset.src;
              image.classList.remove('lazy');
              imageObserver.unobserve(image);
            }
          });
        });
        lazyloadImages.forEach((image) => {
          imageObserver.observe(image);
        });
      }
    },
    setupVeeValidate() {
      // Vee-validate error messages should be set globally
      const dict = {
        custom: {
          formTitle: {
            required: () => 'The title field is required',
          },
          formFirstname: {
            required: () => 'The first name field is required',
          },
          formLastname: {
            required: () => 'The last name field is required',
          },
          address1: {
            required: 'The address field is required',
          },
          country2: {
            required: () => 'The country field is required',
          },
          passenger_name: {
            required: () => 'The passenger name field is required',
          },
          flight_number: {
            required: () => 'The flight number field is required',
          },
          contact_number: {
            required: () => 'The contact number field is required',
          },
          pickupTime_hour: {
            required: () => 'The hour field is required',
          },
          pickupTime_minute: {
            required: () => 'The minute field is required',
          },
          arrivalTime_hour: {
            required: () => 'The hour field is required',
          },
          arrivalTime_minute: {
            required: () => 'The minute field is required',
          },
        },
      };
      this.$validator.localize('en', dict);
    },
    handleFlagSetRequest() {
      if (this.$route.query.ct && this.$route.query.m) {
        this.$store.dispatch('contacts/setFlagByToken', { token: this.$route.query.ct, flagname: 'mallorcainterest' }).then((res) => { console.log(res); }).catch((err) => { console.log(err); });
      } else if (this.$route.query.ct && this.$route.query.v) {
        this.$store.dispatch('contacts/setFlagByToken', { token: this.$route.query.ct, flagname: 'newvillasinterest' }).then((res) => { console.log(res); }).catch((err) => { console.log(err); });
      } else if (this.$route.query.ct && this.$route.query.wk) {
        // make sure the auto CTA for whitekey interest does not happen now
        window.$cookies.set('WKDestinationPopupViewed', true, new Date(new Date().setFullYear(new Date().getFullYear() + 1)));
        this.$store.commit('common/setCookieNewDestinationViewed', true);

        // flag the interest on user record
        this.$store.dispatch('contacts/setFlagByToken', { token: this.$route.query.ct, flagname: 'wkinterest' }).then((res) => { console.log(res); }).catch((err) => { console.log(err); });
      }
    },
  },

};
</script>

<style lang="scss">

@import "./assets/styles/main.scss";
@import "./assets/styles/components/_vue_tour.scss";
#cm-ov {
  background: rgba(4,6,8,.5);
}
.fullscreen-cover{
    position: fixed;
    z-index: 9999; //important for slideshow do not change
    top: 0px;
    left:0px;
    width: 100vw;
    height: 100vh;
    background-color: $black;
    overflow: hidden;
}

.app-content {
  /* Wimpie: Added this to prevent footer from jumping to the top of the page when switching from on page to the next.*/
  min-height: 500px;
  /* overflow: hidden; */ /* Jamie 28/03: can this be removed? */
}

.app-conent-normal{
  // use for non sca styles if needed
}
.app-conent-sca{
  margin: 20px 34px 50px 34px;
  height: 100%;
  display: block;
  @media (max-width: 950px) {
    margin: 80px 20px 50px 20px;
  }
  @media (max-width: 400px) {
    margin: 80px 10px 50px 10px;
  }
}

.sca-nav{
  position: relative;
  top:0;
  left: 0;
  z-index: 100;
}

.nav-margin {
   // LARGEST BREAKPOINT
    //  top bar - 39.5px
    //  main nav - 71px
    //  navDrawer bar - 40px
    //  bottom border - 1px
    margin-top: 111px;

    @media (max-width: 900px) {
    //  top bar - 39.5px
    //  mobile nav - 56px
      margin-top: 56px;
    }

    //  @media (max-width: 768px) {
    // //  top bar - 59px
    // //  mobile nav - 56px
    //   margin-top: 115px;
    // }

    @media (max-width: 575px) {
   //  top bar - 59px
    //  mobile nav - 56px
      margin-top: 56px;
    }
  }

  // Animate main content when the route is changing to refactor later
  .slide-enter-active {
    animation: slide-in 100ms ease-out forwards;
  }

  .slide-leave-active {
    animation: slide-out 100ms ease-out forwards;
  }

  @keyframes slide-in {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }

    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-out {
    from {
      transform: translateY(0);
      opacity: 1;
    }

    to {
      transform: translateY(-30px);
      opacity: 0;
    }
  }

  .pace {
    -webkit-pointer-events: none;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }

  .pace-inactive {
      display: none;
  }

  .pace .pace-progress {
    background: #29d;
    position: fixed;
    z-index: 2000;
    top: 0;
    right: 100%;
    width: 100%;
    height: 2px;
  }

  #s-cnt .title {
      width:auto !important;
  }

  .fade-leave-active {
  transition: opacity 0.5s linear;
  }
  .fade-leave-to {
    opacity: 0;
  }

</style>
